import { execute } from '@/graphql/execute';
import { getProjectQuery } from '@/queries/project.query';
import { useQuery } from '@tanstack/react-query';
import { FunctionComponent } from 'react';
import { Outlet, useParams } from 'react-router';

interface iProjectWrapperProps {}

const ProjectWrapper: FunctionComponent<iProjectWrapperProps> = () => {
  const { projectId } = useParams();
  if (!projectId) throw new Error('Project ID is required');

  const { data, isLoading, error } = useQuery({
    queryKey: ['project', projectId],
    queryFn: () => execute(getProjectQuery, { id: projectId }),
  });

  const project = data?.project;
  const href = `/projects/${projectId}`;
  return (
    <Outlet
      context={{
        project,
        projectLoading: isLoading,
        projectError: error,
        href,
      }}
    />
  );
};

export default ProjectWrapper;
